<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      :itemNames="['name_1','name_2','name_3','name_4','name_5']"
      :columns="getColumns()"
      :col="4"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
      :showResetButton="true"
      @reset="resetEvent"
    >
      <a-form-item slot="name_1" label="订单编号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.ddbh" :maxLength="50" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="name_2" label="预订人姓名" v-bind="searchItemLayout">
        <a-input v-model="queryParams.ydrxm" :maxLength="50" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="name_3" label="订单类型" v-bind="searchItemLayout">
        <a-select v-model="queryParams.ddlx" style="width: 100%" allowClear placeholder="请选择"
                  @change="(e) => onSelectOrderType(e,'hotel')">
          <a-select-option
            v-for="(item,index) in hotelOrderTypeList"
            :key="index"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="name_4" label="订单状态" v-bind="searchItemLayout">
        <a-select v-model="queryParams.ddzt" style="width: 100%" allowClear placeholder="请选择">
          <a-select-option
            v-for="(item,index) in hotelOrderStatusList"
            :key="index"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="name_5" label="预订时间" v-bind="searchItemLayout">
        <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
      </a-form-item>
      <span slot="action" slot-scope="rowItem">
        <a @click="toDetailEvent(rowItem.record)">详情</a>
      </span>
    </search-page-view>

    <a-modal
      title='订单详情'
      okText="保存"
      :visible='modalVisible'
      width="1300px"
      @cancel="cancelEvent"
      :footer="null"
    >
      <a-form-model
        class="custom-form"
        :model="orderDetail"
        ref="ruleForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <div v-for="(section, index) in detailSections" :key="index">
          <div class="row-title">{{ section.title }}</div>
          <!-- 按每行4个字段分组 -->
          <a-row v-for="(row, rowIndex) in chunkArray(section.fields)" :key="rowIndex">
            <a-col :span="6" v-for="field in row" :key="field.key">
              <a-form-model-item :label="field.label">
                {{ orderDetail[field.key] }}
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import WelfareMallMixins from '@/views/service/serviceProvider/welfareMall/mixins/WelfareMallMixins'

export default {
  name: 'WelfareMallHotelOrder',
  mixins: [WelfareMallMixins],
  data() {
    return {
      queryParams: {},
      searchItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      selectedDate: null,
      modalVisible: false,
      orderDetail: {},
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      detailSections: [
        {
          title: '基本信息',
          fields: [
            { label: '申请编号', key: 'sqdh' },
            { label: '订单类型', key: 'ddlx_str' },
            { label: '订单状态', key: 'ddzt_str' },
            { label: '预订时间', key: 'dpDatetime' },
            { label: '联系人姓名', key: 'lxrxm' },
            { label: '联系人电话', key: 'lxrdh' },
            { label: '订单来源', key: 'ddly' },
            { label: '间夜数', key: 'days' },
            { label: '入住人数', key: 'rzrs' },
            { label: '预订人姓名', key: 'ydrxm' },
            { label: '出行人电话', key: 'travelPhone' }
          ]
        },
        {
          title: '支付信息',
          fields: [
            { label: '订单编号', key: 'ddbh' },
            { label: '销售价', key: 'xsj' },
            { label: '服务费', key: 'fwf' },
            { label: '退票手续费', key: 'tpf' },
            { label: '其他费用', key: 'qt' },
            { label: '业务发生时间', key: 'ywfssj' },
            { label: '费控总合计', key: 'fyje' },
            { label: '付款方式', key: 'fkfs' },
            { label: '是否月结', key: 'sfyj' },
            { label: '实际超标金额', key: 'sjcbje' }
          ]
        }
      ]
    }
  },
  methods: {
    getListPromise(params) {
      return this.getHttpServices().getOrderService().post('shengYiHotelOrder/pageList', params)
    },
    getColumns() {
      return [
        {
          title: '订单编号',
          dataIndex: 'ddbh'
        },
        {
          title: '订单类型',
          dataIndex: 'ddlx_str'
        },
        {
          title: '联系人姓名',
          dataIndex: 'lxrdh'
        },
        {
          title: '联系人电话',
          dataIndex: 'lxrxm'
        },
        {
          title: '间夜数',
          dataIndex: 'days'
        },
        {
          title: '入住人数',
          dataIndex: 'rzrs'
        },
        {
          title: '订单总价',
          dataIndex: 'originalCurrencySum'
        },
        {
          title: '订单状态',
          dataIndex: 'ddzt_str'
        },
        {
          title: '预订时间',
          dataIndex: 'dpDatetime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    resetEvent() {
      this.queryParams = {}
      this.selectedDate = null
      setTimeout(() => {
        this.$refs.pageList.refresh(true)
      }, 200)
    },
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.dpDatetime_start = dateStrArr[0]//开始日期
      this.queryParams.dpDatetime_end = dateStrArr[1]//结束日期
    },
    async toDetailEvent(record) {
      this.orderDetail = await this.getOrderDetail(record)
      this.modalVisible = true
    },
    getOrderDetail(record) {
      return new Promise(resolve => {
        this.getHttpServices().getOrderService().post('shengYiHotelOrder/detail', {
          ddbh: record.ddbh
        }).then(res => {
          resolve(res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      })
    },
    cancelEvent() {
      this.modalVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.row-title {
  position: relative;
  padding: 5px 10px;
  font-size: 16px;
  font-weight: bold;

  &::before {
    content: "";
    position: absolute;
    width: 2px;
    height: 18px;
    background-color: cornflowerblue;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
}

.custom-form {
  .ant-form-item {
    margin-bottom: 0;
  }
}
</style>
